<style scoped>
	.main-slot-box {
		padding-bottom: 50px;
	}

	.my-money-box {
		background: rgba(11, 119, 206, .06);
		margin: 20px 20px 0 20px;
		border-top: 4px solid rgba(11, 119, 206, .06);
		text-align: left;
		padding-bottom: 10px;
	}

	.margin-20 {
		margin: 20px 30px !important;
	}

	.my-money-box>.my-money-title {
		font-size: 16px;
		font-weight: bold;
		margin-top: 30px !important;
	}

	.my-money-box>.my-money-num {
		font-size: 30px;
		font-weight: bold;
	}

	.my-money-box>.my-money-num .num {
		font-size: 40px;
	}

	.my-money-box>.my-money-c-btn {
		display: flex;
	}

	.my-money-box>.my-money-c-btn>.c-btn {
		width: 124px;
		height: 36px;
		border-radius: 2px;
		text-align: center;
		line-height: 36px;
		font-size: 14px;
		margin: 0 20px 0 0;
	}

	.my-money-box>.my-money-c-btn>.c-btn:nth-child(1) {
		color: #fff;
		background: linear-gradient(0deg, rgba(5, 115, 203, 1) 0%, rgba(63, 159, 234, 1) 100%);
	}

	.my-money-box>.my-money-c-btn>.c-btn:nth-child(2) {
		border: 1px solid #0B77CE;
		color: #0B77CE;
	}

	/* two tables ... */
	.table-box {
		margin: 0 20px;
	}

	.table-box>.table-title {
		text-align: left;
		font-weight: bold;
		font-size: 14px;
		margin: 30px 0 10px 0 !important;
	}

	.sun {
		margin-right: 5px;
		color: #3F9FEA;
	}
	.ml100{
		margin-left: 100px;
	}
</style>

<template>
	<SecondaryPageComponent :type-list="$t('accountBalance.typeList')" :type-change-event="typeChange">
		<!--内容面板-->
		<div slot="content-slot" class="main-slot-box">
			<div class="my-money-box">
				<p class="my-money-title margin-20">{{$t('accountBalance.my')}}{{classType === 0 ? $t('accountBalance.wallet') : $t('accountBalance.integral')}}</p>
				<p v-if="classType === 0" class="my-money-num margin-20">
					<span>{{`${$type == 1?'￥':'$'}`}}<span class="num">{{(accountDetail.accountBalance / 100).toFixed(2)}}</span></span>
					<!--<span class="ml100">{{`${$type == 1?'￥':'$'}`}}<span class="num">{{(accountDetail.balanceUs / 100).toFixed(2)}}</span></span>-->
				</p>
				<p v-else-if="classType === 1" class="my-money-num margin-20"><span class="num">{{accountDetail.integralBalance}}</span></p>
				<div class="my-money-c-btn margin-20" v-if="classType === 0" @click="cz_tx">
					<a class="c-btn" href="javascript:void(0);" data-btntype="cz">{{$t('accountBalance.Recharge')}}</a>
					<a class="c-btn" href="javascript:void(0);" data-btntype="tx">{{$t('accountBalance.Withdrawal')}}</a>
				</div>
			</div>
			<div v-if="classType === 0" class="table-box">
				<!-- 账单... -->
				<p class="table-title">{{$t('accountBalance.bill')}}</p>
				<div class="pay-record">
					<div class="c-t-head">
						<div v-for="item in payHead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
					</div>
					<div class="c-t-body">
						<div class="row" v-if="dataPayList.length <= 0"><span class="none-data">{{$t('accountBalance.no')}}...</span></div>
						<div v-if="dataPayList.length > 0" class="row" v-for="(outItem,outIndex) in dataPayList">
							<div v-for="(item,index) in payHead" class="col" :class="item.width + ' ' + item.align">
								<template v-if="index === 0">{{outItem.dealTime}}</template>
								<template v-if="index === 1"><span class="sun">{{outItem.budget == 0?'+':'-'}} {{(outItem.amount / 100).toFixed(2)}}</span>
								</template>
								<!-- TODO 充值这里的类型对应的字段待确认 -->
								<template v-if="index === 2">{{
									outItem.dealType == 1 ? $t('accountBalance.apply') :
									 outItem.dealType == 2 ? $t('accountBalance.Withdrawalrefund'):
									  outItem.dealType == 3 ? $t('accountBalance.Accountrecharge') :
									   outItem.dealType == 4 ? $t('accountBalance.Paymentorder') : $t('accountBalance.Orderrefund')}}</template>
								<template v-if="index === 3">{{outItem.objectId}}</template>
								<template v-if="index === 4">
									<!--{{outItem.accountType === 1 ? $t('accountBalance.balance'): $t('accountBalance.dollar')}}-->
									{{$type === 1 ? $t('accountBalance.balance'): $t('accountBalance.dollar')}}
								</template>
							</div>
						</div>
					</div>
					<br />
					<el-pagination @current-change="handleCurrentChangePay" :current-page="payPager.pageNum" :page-size="publicPageSize"
					 layout="total, prev, pager, next, jumper" :total="payPager.totalDataCounts">
					</el-pagination>
				</div>
				<!-- 提现记录...  -->
				<p class="table-title">{{$t('accountBalance.record')}}</p>
				<div class="cash-record">
					<div class="c-t-head">
						<div v-for="item in cashHead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
					</div>
					<div class="c-t-body">
						<div class="row" v-if="dataCashList.length <= 0"><span class="none-data">{{$t('accountBalance.no')}}...</span></div>
						<div v-if="dataCashList.length > 0" class="row" v-for="(outItem,outIndex) in dataCashList">
							<div v-for="(item,index) in cashHead" class="col" :class="item.width + ' ' + item.align">
								<template v-if="index === 0">{{outItem.createTime}}</template>
								<template v-if="index === 1">{{(outItem.cashAmount / 100).toFixed(2)}}</template>
								<template v-if="index === 2">{{outItem.cashType === 1 ? $t('accountBalance.Alipay') : 'PayPal'}}</template>
								<template v-if="index === 3">
									<span style="color:#0B77CE;">
										{{outItem.examState === 1 ? $t('accountBalance.stay') : outItem.examState === 2 ? $t('accountBalance.adopt') : $t('accountBalance.reject')}}
									</span>
								</template>
							</div>
						</div>
					</div>
					<br />
					<el-pagination @current-change="handleCurrentChangeCash" :current-page="cashPager.pageNum" :page-size="publicPageSize"
					 layout="total, prev, pager, next, jumper" :total="cashPager.totalDataCounts">
					</el-pagination>
				</div>
			</div>
			<div v-else-if="classType === 1" class="table-box">
				<!-- 积分记录...  -->
				<p class="table-title">{{$t('accountBalance.integralRecord')}}</p>
				<div class="cash-record">
					<div class="c-t-head">
						<div v-for="item in integralHead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
					</div>
					<div class="c-t-body">
						<div class="row" v-if="dataIntegralList.length <= 0"><span class="none-data">{{$t('vip.available')}}...</span></div>
						<div v-if="dataIntegralList.length > 0" class="row" v-for="(outItem,outIndex) in dataIntegralList">
							<div v-for="(item,index) in integralHead" class="col" :class="item.width + ' ' + item.align">
								<template v-if="index === 0">{{outItem.createTime}}</template>
								<!--TODO 积分类型-->
								<template v-if="index === 1">{{
									outItem.flowType == 1 ? $t('accountBalance.Sampleapplication'):
									outItem.flowType == 2 ? $t('accountBalance.deduction'):
									outItem.flowType == 3 ? $t('accountBalance.Closeorder'):
									 $t('accountBalance.Completeorder')
									}}</template>
								<template v-if="index === 2">{{outItem.objectId}}</template>
								<template v-if="index === 3"><span class="sun">{{outItem.budget == 0?'+':'-'}} {{outItem.flowNum}}</span></template>
							</div>
						</div>
					</div>
					<br />
					<el-pagination @current-change="handleCurrentChangeIntegral" :current-page="integralPager.pageNum" :page-size="publicPageSize"
					 layout="total, prev, pager, next, jumper" :total="integralPager.totalDataCounts">
					</el-pagination>
				</div>
			</div>
		</div>

		<PayOkConfirm v-if="loadingPay" slot="model-slot" @click-emit-reload="reloadBtn" />
	</SecondaryPageComponent>
</template>

<script>
	import '../../../assets/css/l-table.css';
	import SecondaryPageComponent from '../../assembly/SecondaryPageComponent';
	import PayOkConfirm from '../../assembly/PayOkConfirm';

	export default {
		name: 'MyBalance',
		components: {
			SecondaryPageComponent,
			PayOkConfirm
		},
		data() {
			return {
				loadingPay: false,
				token: '',
				typeList: ['我的钱包', '我的积分'],
				classType: 0,
				accountDetail: {},
				payHead: [],
				cashHead: [],
				integralHead: [],
				dataIntegralList: [],
				dataPayList: [],
				dataCashList: [],
				publicPageSize: 5,
				payPager: {
					totalDataCounts: 0,
					pageNum: 1
				},
				cashPager: {
					totalDataCounts: 0,
					pageNum: 1
				},
				integralPager: {
					totalDataCounts: 0,
					pageNum: 1
				}
			};
		},
		created() {
			this.typeList = this.$t('accountBalance.typeList')
			this.payHead = this.$t('accountBalance.payHead')
			this.cashHead = this.$t('accountBalance.cashHead')
			this.integralHead = this.$t('accountBalance.integralHead')
			this.token = sessionStorage.getItem('token');
			this.loadBalance();
			this.loadData('pay', 1);
			this.loadData('cash', 1);
		},
		methods: {
			reloadBtn() {
				this.loadingPay = false
				this.loadBalance();
				this.loadData('pay', 1);
				this.loadData('cash', 1);
			},
			//充值和提现
			cz_tx(e) {
				let btn = e.target.dataset['btntype'];
				if (btn !== 'cz' && btn !== 'tx') return;
				sessionStorage.setItem("routerlinkchargecash", JSON.stringify({
					type: btn
				}));
				switch (btn) {
					case 'cz':
						{
							this.loadingPay = true;
							let routerLinkData = this.$router.resolve('/cash/charge');
							window.open(routerLinkData.href, '_blank');
						}
						break;
					case 'tx':
						this.$router.push('/cash/charge');
						break;
				}
				e.cancelBubble = true;
			},
			//类型改变的时候
			typeChange(index) {
				this.classType = index;
				if (index === 0) {
					this.loadData('pay', this.payPager.pageNum);
					this.loadData('cash', this.cashPager.pageNum);
				} else if (index === 1) {
					this.loadData('integral', this.integralPager.pageNum);
				}
			},
			//提现记录分页
			handleCurrentChangeCash(pageNum) {
				this.cashPager.pageNum = pageNum;
				this.loadData('cash', pageNum);
			},
			//账单分页
			handleCurrentChangePay(pageNum) {
				this.payPager.pageNum = pageNum;
				this.loadData('pay', pageNum);
			},
			//积分
			handleCurrentChangeIntegral(pageNum) {
				this.integralPager.pageNum = pageNum;
				this.loadData('integral', pageNum);
			},
			//加载数据
			loadData(type = 'pay', pageNum = 1) {
				let url = '';
				switch (type) {
					case 'pay':
						url = 'api/account/getAmountStreamAll';
						break;
					case 'cash':
						url = 'api/cash/list';
						break;
					case 'integral':
						url = 'api/account/getIntegralFlowAll';
						break;
				}
				if (!url) return;
				this.$get(url, {
					token: this.token,
					pageSize: this.publicPageSize,
					pageNum
				}).then(res => {
					if (res.code === 0) {
						switch (type) {
							case 'pay':
								{
									this.dataPayList = res.data;
									this.payPager.totalDataCounts = res.params.totalDataCounts;
								}
								break;
							case 'cash':
								{
									this.dataCashList = res.data;
									this.cashPager.totalDataCounts = res.params.totalDataCounts;
								}
								break;
							case 'integral':
								{
									this.dataIntegralList = res.data;
									this.integralPager.totalDataCounts = res.params.totalDataCounts;
								}
								break;
						}
					}
				});
			},
			//加载账户余额
			loadBalance() {
				this.$get('api/account/getAccountAll', {
					token: this.token
				}).then(res => {
					if (res.code === 0) {
						this.accountDetail = res.data;
					}
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/balance/MyBalance.vue